import "./vertical-divider-component-styles.scss";

const VerticalDividerComponent = ({ imgSrc }) => {
	return (
		<img
			src={imgSrc}
			alt="moazam dev vertical divider"
			className="vertical-divider"
		/>
	);
};

export default VerticalDividerComponent;
